// Mirror of apolo-api/src/lib/externalSignalCollector.js (pure, no I/O).

const AUTO_PR_ACTORS = new Set([
  'apolo-auto-pr',
  'apolo-bot',
  'github-actions[bot]',
  'web-flow',
]);

const DAY_MS = 86_400_000;

export function isHumanMerge({ merged, mergedBy, autoMerged = false } = {}) {
  if (!merged) return false;
  if (autoMerged) return false;
  if (!mergedBy || typeof mergedBy !== 'string') return false;
  if (AUTO_PR_ACTORS.has(mergedBy)) return false;
  return true;
}

export function computeSurvivedDays({ createdAt, now, reverted } = {}) {
  if (reverted) return 0;
  const start = createdAt ? new Date(createdAt).getTime() : NaN;
  const end = now ? new Date(now).getTime() : NaN;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return 0;
  return Math.floor((end - start) / DAY_MS);
}

export function deriveExternalSignal(evidence = {}) {
  const reverted = evidence.reverted ? 1 : 0;
  // null (NOT 0) when NOT a human merge — keeps the column OPEN so the later
  // remote-merge back-fill can land the strong signal. Mirrors apolo-api.
  const human_merged = isHumanMerge(evidence) ? 1 : null;
  const survived_days = computeSurvivedDays(evidence);
  return { human_merged, reverted, survived_days };
}
